import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "chart-container" }
const _hoisted_2 = { class: "period-selector" }
const _hoisted_3 = {
  key: 0,
  class: "custom-period"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPeriod) = $event)),
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlePeriodChange && _ctx.handlePeriodChange(...args)))
      }, _cache[5] || (_cache[5] = [
        _createElementVNode("option", { value: "week" }, "Les 7 derniers Jours", -1),
        _createElementVNode("option", { value: "month" }, "Les 30 derniers Jours", -1),
        _createElementVNode("option", { value: "custom" }, "Période personnalisée", -1)
      ]), 544), [
        [_vModelSelect, _ctx.selectedPeriod]
      ]),
      (_ctx.selectedPeriod === 'custom')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.startDate) = $event))
            }, null, 512), [
              [_vModelText, _ctx.startDate]
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "à", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endDate) = $event))
            }, null, 512), [
              [_vModelText, _ctx.endDate]
            ]),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fetchCustomData && _ctx.fetchCustomData(...args))),
              class: "submit-btn"
            }, "Valider")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_apexchart, {
      type: "bar",
      height: "350",
      options: _ctx.chartOptions,
      series: _ctx.series
    }, null, 8, ["options", "series"])
  ]))
}